import React from 'react';
import { connect } from 'react-redux';
import { ChanelConfig } from '../../../../../configs/GlobalConfig';
import MessageHub from '../../../../../core/signalr/SignalrMessageHub';
import {
  cancelfetchDataOverview,
  fetchListDeceptiveData,
  loadMoreOverview,
  subscribeRealtimeTickDeceptive,
} from '../reducer';
import { REDUCER_NAME } from '../reducer';
import Table from './Table';

class Overview extends React.Component {
  componentDidMount() {
    const { fetchListDeceptiveData } = this.props;
    fetchListDeceptiveData();
    MessageHub.subscribe(ChanelConfig.TickChanel, this.dispatchDataRealtime);
  }

  componentWillReceiveProps(nextProps, nextContext) {
    const { currentSearch, watchListId } = this.props;
    if (
      currentSearch !== nextProps.currentSearch ||
      watchListId !== nextProps.watchListId
    ) {
      this.setState({
        page: 1,
      });
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { currentSearch, fetchListDeceptiveData, watchListId } = this.props;
    if (
      currentSearch !== prevProps.currentSearch ||
      watchListId !== prevProps.watchListId
    ) {
      fetchListDeceptiveData(watchListId);
    }
  }

  componentWillUnmount() {
    const { cancelfetchDataOverview } = this.props;
    cancelfetchDataOverview();
    MessageHub.unsubscribe(ChanelConfig.TickChanel, this.dispatchDataRealtime);
  }

  dispatchDataRealtime = data => {
    const { subscribeRealtimeTickDeceptive } = this.props;
    subscribeRealtimeTickDeceptive(data);
  };

  render() {
    return <Table />;
  }
}

const mapStateToProps = state => {
  return {
    i18n: state.i18n,
    watchListId: state[REDUCER_NAME].watchListId,
    currentSearch: state[REDUCER_NAME].currentSearch,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    cancelfetchDataOverview: () => dispatch(cancelfetchDataOverview()),
    fetchListDeceptiveData: wlId => dispatch(fetchListDeceptiveData(wlId)),
    loadMoreOverview: data => dispatch(loadMoreOverview(data)),
    subscribeRealtimeTickDeceptive: data =>
      dispatch(subscribeRealtimeTickDeceptive(data)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Overview);
